
import { createApiRef } from '@backstage/core-plugin-api';












export var TimeRangeList; (function (TimeRangeList) {
  const AN_HOUR = '1 Hour'; TimeRangeList["AN_HOUR"] = AN_HOUR;
  const A_DAY = '1 Day'; TimeRangeList["A_DAY"] = A_DAY;
  const A_WEEK = '1 Week'; TimeRangeList["A_WEEK"] = A_WEEK;
})(TimeRangeList || (TimeRangeList = {}));

export var AlertType; (function (AlertType) {
  const CRITICAL = 'P1'; AlertType["CRITICAL"] = CRITICAL;
  const WARNING = 'P2'; AlertType["WARNING"] = WARNING;
  const NOTIFICATION = 'P3'; AlertType["NOTIFICATION"] = NOTIFICATION;
})(AlertType || (AlertType = {}));

export var ActionType; (function (ActionType) {
  const CREATE = 'create'; ActionType["CREATE"] = CREATE;
  const ACKNOWLEDGE = 'acknowledge'; ActionType["ACKNOWLEDGE"] = ACKNOWLEDGE;
  const CLOSE = 'close'; ActionType["CLOSE"] = CLOSE;
})(ActionType || (ActionType = {}));

export var AlertStatus; (function (AlertStatus) {
  const TODO = 'to-do'; AlertStatus["TODO"] = TODO;
  const IN_PROGRESS = 'indeterminate'; AlertStatus["IN_PROGRESS"] = IN_PROGRESS;
  const DONE = 'done'; AlertStatus["DONE"] = DONE;
})(AlertStatus || (AlertStatus = {}));

export var AlertOpsgenieStatus; (function (AlertOpsgenieStatus) {
  const CLOSED = 'closed'; AlertOpsgenieStatus["CLOSED"] = CLOSED;
  const OPEN = 'open'; AlertOpsgenieStatus["OPEN"] = OPEN;
  const ACKNOWLEDGED = 'acknowledged'; AlertOpsgenieStatus["ACKNOWLEDGED"] = ACKNOWLEDGED;
  const SNOOZED = 'snoozed'; AlertOpsgenieStatus["SNOOZED"] = SNOOZED;
  const IN_PROGRESS = 'in progress'; AlertOpsgenieStatus["IN_PROGRESS"] = IN_PROGRESS;
  const RESOLVED = 'resolved'; AlertOpsgenieStatus["RESOLVED"] = RESOLVED;
  const CANCELLED = 'cancelled'; AlertOpsgenieStatus["CANCELLED"] = CANCELLED;
})(AlertOpsgenieStatus || (AlertOpsgenieStatus = {}));

export var AlertUrlQuery; (function (AlertUrlQuery) {
  const START_TIME = 'startTime'; AlertUrlQuery["START_TIME"] = START_TIME;
  const END_TIME = 'endTime'; AlertUrlQuery["END_TIME"] = END_TIME;
  const ENV_NAME = 'clusterId'; AlertUrlQuery["ENV_NAME"] = ENV_NAME;
  const OFFSET = 'offset'; AlertUrlQuery["OFFSET"] = OFFSET;
  const LIMIT = 'limit'; AlertUrlQuery["LIMIT"] = LIMIT;
  const TAG = 'tag'; AlertUrlQuery["TAG"] = TAG;
  const TYPE = 'priority'; AlertUrlQuery["TYPE"] = TYPE;
  const IS_EXACT = 'isExact'; AlertUrlQuery["IS_EXACT"] = IS_EXACT;
  const TIME_RANGE = 'timeRange'; AlertUrlQuery["TIME_RANGE"] = TIME_RANGE;
})(AlertUrlQuery || (AlertUrlQuery = {}));

export var ChartCategorizing; (function (ChartCategorizing) {
  const MINUTE = 'minute'; ChartCategorizing["MINUTE"] = MINUTE;
  const HOUR = 'hour'; ChartCategorizing["HOUR"] = HOUR;
  const DAY = 'day'; ChartCategorizing["DAY"] = DAY;
})(ChartCategorizing || (ChartCategorizing = {}));



























































































/**
 * ApiRef for the AlertAPI.
 *
 * @public
 */
export const AlertAPIRef = createApiRef({
  id: 'plugin.alert.api',
});












































































































































































































































































































































